/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
/* eslint-disable indent */
// Libraries
import { MAKER_CHECKER_EVENT_TYPES } from 'utils/constants/commonValues';
import {
    formatFormDataOptions,
    getDependentSectionName,
    getFormButtonText,
    nameValueOptions,
} from '../../utils/helperMethods';
import { FormElems, Alert, AlertModal, Accordion, CustomDate } from '../../components/';
import {
    saveAndContinueRequest,
    resetSaveDataSuccessKey,
    submitStepFormRequest,
} from '../../containers/MerchantOnboard/redux/merchantOnBoard.actions';
import {
    resetUpdateDataSuccessKey,
    getMerchantInfoRequest,
    fetchBasicFormData,
    updateSettlementDataRequest,
    addMerchantStepUpdateMakerRequest,
    getMerchantSectionInfoRequest,
} from '../../containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';
import validate, { validateReports } from './validator';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes, { object } from 'prop-types';
import { Field, reduxForm, change, FieldArray } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { last, first, iteratee } from 'lodash';
import { initialBankAccount, initialEDIData, multipleAdditionalDoc } from './constants';
import info_image from "../../static/images/info.svg"
import Tooltip from 'rc-tooltip';
import { change as changeValue } from 'redux-form';
import MerchantReportModal from '../SettlementTab/MerchantReportModal';
import TermsConditions from "./TermsConditions";
// Actions

// Constant

// Validator

// Styles
import './settlement.scss';
import { POST } from '../../utils/fetchWrappers';
import { API_UPLOAD_KYC_DOCUMENT, API_VIEW_KYC_DOCUMENT } from '../../utils/API/apiUrls';
import { apiStatusCodes } from '../../utils/API/apiStatusCodes';
import infoIcon from '../../static/images/blackinfo.png';
const INTERIM_OPTIONS = [
     'BLANK',
    'TRANSACTION_ID',
    'ORDER_ID',
    'RECON_ID',
    'PAYABLE_ID',
    'MERCHANT_ID',
];

const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx'];

let initialSettlementTypeOptions = [
    {
        name: 'Instant Settlement',
        value: 'ID',
    },
    {
        name: 'On Demand Settlement',
        value: 'ODS',
    },
]

const SettlementTab = ({
    merchantData,
    handleSubmit,
    error,
    nextPath,
    previousPath,
    history,
    actions,
    sectionType,
    name,
    auth,
    initialValues,
    isEditMode,
    isViewMode,
    editData,
    draftData,
    change,
    onBoardSteps,
    formData,
    merchantLegalEntityData
}) => {
    const {
        saveData,
        timeline: { fields },
        formInProcess = [],
        uniqueIdentifier: { uniqueId },
    } = merchantData;

    let firstCall = false;
    const [isShowModalAccount, setIsShowModalAccount] = useState(false);
    const [isShowModalSettlement, setIsShowModalSettlement] = useState(false);
    const [settlementErrorMessage, setSettlementErrorMessage] = useState(false);
    const { updateData, basicFormData = {}, sections = [] } = editData;
    const { userDetails } = auth;
    const { location } = history;
    const [switchState, setSwitchState] = useState({
        hierarchyCommission: false,
        refundWithNegativeBalanceFlag: false,
        isSettlementEnable: true,
        isPayableEnable: true,
        isZeroSettlementEnabled: false,
    });
    const currentStep = first(
        onBoardSteps.filter(item => item.sectionType === sectionType)
    );
    //console.log(currentStep," currentStep---------");
    const [isChange, setIsChange] = useState(false);
    const [customError, setCustomError] = useState({ fcCommissionType: '' });
    const isOrAre = currentStep.dependentSections.length > 1 ? 'are' : 'is';
    const [accountErrorMessage, setAccountErrorMessage] = useState(false);
    const [isShowModal, setIsShowModal] = useState(false);
    const [interimOptions, setInterimOptions] = useState(INTERIM_OPTIONS);
    const [secondInterimOptions, setSecondInterimOptions] = useState(
        INTERIM_OPTIONS
    );
    const [formValues, setFormValues] = useState({});
    const [formConfirmation, setFormConfirmation] = useState(false);

    const [oldFormData, setOldFormData] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [isMRViewMode, setIsMRViewMode] = useState(false);
    const [selectedReportType, setSelectedReportType] = useState('');
    const [termsConditionView, setTermsConditionsView] = useState(false);
    const [settlementConfirmation, setSettlementConfirmation] = useState(false);
    const [settlementTypeOptions, setSettlementTypeOptions] = useState(initialSettlementTypeOptions);

    useEffect(() => {
        if (
            !oldFormData &&
            formData.values.nextSettlementType !== undefined &&
            formData.values.fcCommissionType
        ) {
            setOldFormData(formData.values);
        }
    }, [formData.values, oldFormData]);

    const dispatch = useDispatch();

    const instantSettlementOptions = [
        {
            name: 'Instant Settlement',
            value: 'instantSettlement',
            checked: false,
        },
    ];

    const ancillaryFeeOptions = [
        {
            name: 'Enable Ancillary Fee',
            value: 'isAncillaryFeeEnabled',
            checked: false,
        },
    ];

    const UnifiedMSROptions = [
        {
            name: 'Enable Unified MSR',
            value: 'isUnifiedMsr',
            checked: false,
        },
    ];





    // Determine if the user is in a terminal state based on the presence of 'nextPath'.
    const isUserTerminalState = !nextPath;

    const getCheckboxOptions = (initialValuesData, data, keyField) => {
        if (initialValuesData && initialValuesData[keyField]) {
            return data.map(item => {
                if (initialValuesData[keyField]) {
                    return { ...item, checked: true };
                }
                return item;
            });
        }
        return data;
    };

    const onSuccessModal = () => {
        //console.log("onSuccessModal.........");
        setIsShowModal(false);
        if (formData && formData.values) {
            handleFormSubmit(formData.values);
        }
    };

    const onCloseModal = () => {
        setIsShowModal(false);
    };

    const resetErrors = () => {
        if (isEditMode) {
            actions.resetUpdateDataSuccessKey();
        } else {
            actions.resetSaveDataSuccessKey();
        }
    };

    const onNext = () => {
        resetErrors();
        if (!isUserTerminalState) {
            history.push(nextPath);
        } else {
            history.push('/mob');
        }
    };

    const onBack = () => {
        resetErrors();
        if (!isEditMode && !isViewMode && draftData && editData) {
            history.push('/mob/draft');
        } else {
            history.push(previousPath);
        }
    };

    useEffect(() => {
        if (Object.keys(initialValues).length) {
            const {
                hierarchyCommission,
                refundWithNegativeBalanceFlag,
                isSettlementEnable,
                isPayableEnable,
                isZeroSettlementEnabled,
            } = initialValues;
            const checkHierarchy =
                currentStep.status === 'Open' ? false : hierarchyCommission;
            setSwitchState({
                hierarchyCommission: checkHierarchy,
                refundWithNegativeBalanceFlag,
                isSettlementEnable:
                    typeof isSettlementEnable === 'boolean'
                        ? isSettlementEnable
                        : true,
                isPayableEnable:
                    typeof isPayableEnable === 'boolean'
                        ? isPayableEnable
                        : true,
                isZeroSettlementEnabled:
                    typeof isZeroSettlementEnabled === 'boolean'
                        ? isZeroSettlementEnabled
                        : false,
            });
            if (currentStep.status === 'Open') {
                change('hierarchyCommissionList', []);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValues]);
    /**
     * get form data
     */

    useEffect(() => {
        let req = {};
        if (isEditMode || isViewMode) {
            const merchantId = last(location.pathname.split('/'));
            req = {
                entityCode: merchantId,
                sectionType,
            };
        } else {
            req = {
                uniqueIdentifier: uniqueId,
                userId: userDetails.email,
                formType: 'merchantOnboardingForm',
                sectionType,
            };
        }
        if (!firstCall) {
            //console.log("useEffect formData...  firstCall =>",firstCall)
            actions.fetchBasicFormData(req);
            firstCall = true;
        }
    }, [
        actions,
        userDetails,
        isEditMode,
        isViewMode,
        sectionType,
        formInProcess,
        uniqueId,
        location.pathname,
    ]);
    const [reportParameters, setReportParameters] = useState(null);
    const [finalReports, setFinalReports] = useState({});
    useEffect(() => {
        const settlementSection = editData.sections.find(
            section => section.type === 'settlementSection'
        );
        //user have already selected the reports previously
        if (editData.basicFormData && settlementSection?.data?.customisedReports) {
            editData.basicFormData.defaultReports =
                settlementSection?.data?.customisedReports;
        }
        if (editData && editData?.basicFormData?.defaultReports) {
            const parameters = editData?.basicFormData?.defaultReports;
            setReportParameters(parameters);
            setFinalReports(parameters);
        }
        if (draftData && draftData?.data?.customisedReports) {
            console.log(draftData?.data?.customisedReports, '3333333');
            setReportParameters(draftData?.data?.customisedReports);
        }
    }, [editData, draftData]);

    useEffect(() => {
        const fetchMerchantData = async () => {
            if (isEditMode || isViewMode) {
                const merchantId = last(location.pathname.split('/'));

                try {
                    // First API call
                    await actions.getMerchantSectionInfoRequest(
                        merchantId,
                        fields,
                        'settlementSection'
                    );
                    // Only call the second API if the first one succeeded
                    setTimeout(function() {
                        if (fields?.length) {
                            actions.getMerchantInfoRequest(merchantId, fields);
                        }
                    }, 800);
                } catch (error) {
                    console.error('Error fetching merchant data:', error);
                }
            }
        };

        fetchMerchantData();
    }, [actions, fields, isEditMode, isViewMode, location.pathname]);

    // useEffect(() => {
    //     //this is the config call

    //     if (isEditMode || isViewMode) {
    //         const merchantId = last(location.pathname.split('/'));
    //         actions.getMerchantSectionInfoRequest(
    //             merchantId,
    //             fields,
    //             'settlementSection'
    //         );
    //     }
    // }, [actions, fields, isEditMode, isViewMode, location.pathname]);

    /**
     * get complete merchant info
     */
    // useEffect(() => {
    //     if ((isEditMode || isViewMode) && fields?.length) {
    //         const merchantId = last(location.pathname.split('/'));
    //         actions.getMerchantInfoRequest(merchantId, fields);
    //     }
    // }, [actions, fields, isEditMode, isViewMode, location.pathname]);

    console.log(editData, 'consoling editData after config apiiiiiiiiiiiiii');

    /**
     * Change instantSettlement value to Boolean from Array of String
     */
    useEffect(() => {
        const portalValue = formData.values.instantSettlement;
        if (portalValue === true || portalValue === 'instantSettlement') {
            change('instantSettlement', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('instantSettlement')
        ) {
            change('instantSettlement', true);
        } else {
            change('instantSettlement', false);
            change('narrationConfig.secondInterim.interimType', 'BLANK');
        }
    }, [change, formData.values.instantSettlement]);

    useEffect(() => {
        const portalValue = formData.values.isAncillaryFeeEnabled;
        if (portalValue === true || portalValue === 'isAncillaryFeeEnabled') {
            change('isAncillaryFeeEnabled', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isAncillaryFeeEnabled')
        ) {
            change('isAncillaryFeeEnabled', true);
        } else {
            change('isAncillaryFeeEnabled', false);
        }
    }, [change, formData.values.isAncillaryFeeEnabled]);

    useEffect(() => {
        const portalValue = formData.values.isUnifiedMsr;
        if (portalValue === true || portalValue === 'isUnifiedMsr') {
            change('isUnifiedMsr', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isUnifiedMsr')
        ) {
            change('isUnifiedMsr', true);
        } else {
            change('isUnifiedMsr', false);
        }
    }, [change, formData.values.isUnifiedMsr]);

    useEffect(() => {
        if (saveData.isSuccess && saveData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.SAVE_DATA(name));
            onNext();
        }
        return () => {
            if (saveData.isSuccess && saveData.sectionType === sectionType) {
                actions.resetSaveDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveData.isSuccess, saveData.sectionType]);

    useEffect(() => {
        if (updateData.isUpdated && updateData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.UPDATE_MAKER_REQUEST_SUCCESS(name));
            onNext();
        }
        return () => {
            if (
                updateData.isUpdated &&
                updateData.sectionType === sectionType
            ) {
                actions.resetUpdateDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateData.isUpdated, updateData.sectionType]);

    /**
     * Change custom narration value based on configuration
     */
    useEffect(() => {
        const narrationConfig = formData.values.narrationConfig;
        if (narrationConfig) {
            if (
                narrationConfig &&
                narrationConfig.prefix &&
                narrationConfig.prefix.prefixType !== 'CUSTOM'
            ) {
                change('narrationConfig.prefix.customPrefixIdentifier', null);
            }
        }
    }, [change, formData?.values?.narrationConfig?.prefix?.prefixType]);

    useEffect(() => {
        const narrationConfig = formData.values.narrationConfig;

        if (
            narrationConfig &&
            narrationConfig.secondInterim &&
            narrationConfig.secondInterim.interimType
        ) {
            setInterimOptions(
                INTERIM_OPTIONS.filter(
                    item => item !== narrationConfig.secondInterim.interimType || item === 'BLANK'
                )
            );
        }
    }, [change, formData?.values?.narrationConfig?.secondInterim?.interimType]);

    useEffect(() => {
        const narrationConfig = formData.values.narrationConfig;
        if (
            narrationConfig &&
            narrationConfig.interim &&
            narrationConfig.interim.interimType
        ) {
            setSecondInterimOptions(
                INTERIM_OPTIONS.filter(
                    item => item !== narrationConfig.interim.interimType || item === 'BLANK'
                )
            );
        }
    }, [change, formData?.values?.narrationConfig?.interim?.interimType]);

    useEffect(() => {
        const narrationConfig = formData.values.narrationConfig;
        if (
            narrationConfig &&
            narrationConfig.suffix &&
            narrationConfig.suffix.suffixType !== 'CUSTOM'
        ) {
            change('narrationConfig.suffix.customSuffixIdentifier', null);
        }
    }, [change, formData?.values?.narrationConfig?.suffix?.suffixType]);

    const handleCombinedReports = reports => {
        setFinalReports(reports);
        setModalOpen(false);
    };

    const handleFormSubmit = formvalues => {
        const values = JSON.parse(JSON.stringify(formvalues));
        const source =  merchantLegalEntityData?.formData?.forms?.[0]?.sections?.[0]?.data?.source || '';

        if (values.sameDaySettlement?.includes('ODS')) {
            values.odsFlag = true;
            values.instantSettlement = false;
        } else if (values.sameDaySettlement?.includes('ID')) {
            values.instantSettlement = true;
            values.odsFlag = false;
        } else {
            values.odsFlag = false;
            values.instantSettlement = false;
        }

        if (
            values.sameDaySettlement?.includes('ODS') &&
            values.odsFeeCriteria === 'FEE_PERCENT'
        ) {
            values.feePercent = parseFloat(values.feePercent);
            values.flatFee = null;
        } else if (
            values.sameDaySettlement?.includes('ODS') &&
            values.odsFeeCriteria === 'FEE_FLAT'
        ) {
            values.flatFee = parseFloat(values.flatFee);
            values.feePercent = null;
        } else {
            values.feePercent = null;
            values.flatFee = null;
        }

        delete values.sameDaySettlement;

        setFormValues({});
        let isPrimeryAcc = false;
        let isDuplicateAcc = false;
        let isValidIsfc = true;
        const accountDetails = values.accountDetails;

        accountDetails.map(item => {
            if(source === 'axis' && item.ifscCode && !item.ifscCode.startsWith('UTIB') ){
                isValidIsfc = false;
            }
        });

        if(!isValidIsfc){
            toast.error("Invalid IFSC: Axis Bank IFSC must start with 'UTIB'");
            return;
        }

        for (let i = 0; i < accountDetails.length; i++) {
            if (accountDetails[i].primary) {
                isPrimeryAcc = true;
                break;
            }
        }

        for (let i = 0; i < accountDetails.length; i++) {
            for (let j = i + 1; j < accountDetails.length; j++) {
                if (accountDetails[i].accountNumber === accountDetails[j].accountNumber) {
                    isDuplicateAcc = true;
                    break;
                }
            }
            if (isDuplicateAcc) break;
        }

        if (!isPrimeryAcc) {
            if (values?.accountDetails?.[0]?.accountOwnership === 'LENDER') {
                toast.error('Please add a primary account before adding a lender account.');
            } else {
                toast.error('Please select primary account');
            }
            return;
        }

        if (isDuplicateAcc) {
            toast.error('Account numbers should not be the same');
            return;
        }

        const ediConfInfoList = values.ediConfInfoList;

        console.log(ediConfInfoList, "ediConfInfoList");


        if(ediConfInfoList){
            const isConscent = ediConfInfoList.findIndex(item => item.consent === false);
            if (isConscent >= 0) {
                toast.error('Please read and accept EDI terms and conditions.');
                return;
            }
        }

        if (customError.fcCommissionType !== '') {
            return;
        }
        if (
            currentStep &&
            currentStep.dependentSections &&
            currentStep.dependentSections.length &&
            currentStep.status === 'Complete' &&
            isChange &&
            !isShowModal
        ) {
            setIsShowModal(true);
        } else {
            const valuesCopy = values;
            delete valuesCopy.ediDocs;
            valuesCopy.isAncillaryFeeEnabled = valuesCopy.isAncillaryFeeEnabled
                ? valuesCopy.isAncillaryFeeEnabled
                : false;
            valuesCopy.isUnifiedMsr = valuesCopy.isUnifiedMsr
                ? valuesCopy.isUnifiedMsr
                : false;
            if (valuesCopy.disbursementCycle === 'T0') {
                delete valuesCopy.disbursementTriggerSlot;
            } else {
                delete valuesCopy.disbursementInterval;
                delete valuesCopy.sameDaySettlementCharge;
                valuesCopy.instantSettlement = false;
            }

            console.log(valuesCopy, "valuesCopy");

            const request = {
                uniqueIdentifier: uniqueId,
                sectionType,
                data: {
                    ...valuesCopy,
                    refundWithNegativeBalanceFlag:
                        switchState.refundWithNegativeBalanceFlag,
                    hierarchyCommission: switchState.hierarchyCommission,
                    isSettlementEnable: switchState.isSettlementEnable,
                    isPayableEnable: switchState.isPayableEnable,
                    isZeroSettlementEnabled:
                        switchState.isZeroSettlementEnabled,
                },
                userId: userDetails.email,
                formType: 'merchantOnboardingForm',
            };

            if (isEditMode) {
                const merchantId = last(location.pathname.split('/'));
                const updateRequest = {
                    entityCode: merchantId,
                    ...request.data,
                };

                const makerDetails = {
                    makerId: auth.userDetails.email || '',
                    idempotencyId: merchantId,
                    eventType: MAKER_CHECKER_EVENT_TYPES.SETTLEMENT,
                };

                actions.addMerchantStepUpdateMakerRequest(
                    updateRequest,
                    sectionType,
                    makerDetails,
                    finalReports
                );
            } else if (isViewMode) {
                onNext();
            } else {
                if (isUserTerminalState) {
                    actions.submitStepFormRequest(request, sectionType);
                } else {
                    actions.saveAndContinueRequest(
                        request,
                        sectionType,
                        {},
                        finalReports
                    );
                }
            }
        }
    };



    const errorDetails = isEditMode ? updateData : saveData;

    useEffect(() => {
        const setMdr = section => {
            if (
                formData.values.fcCommissionType === 'SURCHARGE' ||
                formData.values.fcCommissionType === null
            ) {
                dispatch(changeValue('add-settlement-form', section, 'NET'));
                setCustomError({
                    fcCommissionType:
                        'Kindly change your fee type to MDR to enable gross settlement as a next settlement type',
                });
            } else if (
                oldFormData &&
                oldFormData.fcCommissionType === 'SURCHARGE'
            ) {
                dispatch(changeValue('add-settlement-form', section, 'NET'));
                setCustomError({
                    fcCommissionType2:
                        'Kindly save your fee type to MDR to enable gross settlement as a next settlement type',
                });
            }
        };

        if (formData.values.fcCommissionType === 'MDR') {
            setCustomError(pre => ({ ...pre, fcCommissionType: '' }));
        }

        if (isEditMode) {
            if (formData.values.nextSettlementType === 'GROSS') {
                setMdr('nextSettlementType');
            } else if (formData.values.nextSettlementType === null) {
                dispatch(
                    changeValue(
                        'add-settlement-form',
                        'nextSettlementType',
                        formData.values.settlementType
                    )
                );
            }
        } else {
            if (formData.values.settlementType === 'GROSS') {
                setMdr('settlementType');
            }
        }
    }, [
        formData.values.nextSettlementType,
        formData.values.fcCommissionType,
        isEditMode,
        formData.values.settlementType,
        oldFormData,
    ]);

    const settlementChangeDate = () => {
        if (
            formData.values.settlementTypeApplicableDate !== undefined &&
            formData.values.settlementTypeApplicableDate !== null
        ) {
            // Slice the date to get only "YYYY-MM-DD"
            return formData.values.settlementTypeApplicableDate.slice(0, 10);
        } else {
            // Get today's date
            const today = new Date();

            // Get next month's date
            const nextMonth = new Date(
                today.getFullYear(),
                today.getMonth() + 1,
                1
            );

            // Format it to YYYY-MM-DD
            const year = nextMonth.getFullYear();
            const month = String(nextMonth.getMonth() + 1).padStart(2, '0');
            const day = String(nextMonth.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        }
    };

    const confirmFormConfirmation = (values) =>{
        setFormValues(values);
        setFormConfirmation(true);
    }

    const onCloseConfirmation = () =>{
        setFormValues({});
        setFormConfirmation(false);
    }

    const onShowModalConfirmation = () =>{
        handleFormSubmit(formValues);
        setFormConfirmation(false);
    }


    const reRenderAccountDetails = (value) => {
        dispatch(changeValue('add-settlement-form', "accountDetails", value));
    }

    useEffect(() => {
        if(formData.initial && (!formData.initial.accountDetails || formData.initial.accountDetails.length === 0)){
            change( "accountDetails", [initialBankAccount]);
        }
    }, [formData.initial]);

    // This useeffect is the simple fix for the validator function so that the function should get latest data
    useEffect(() => {
        if (formData.initial && (isViewMode || isEditMode)) {
            change( "refresh", true);
        }
    }, [formData.initial, change, isEditMode, isViewMode]);

    const handleSettlementChange = (value, data) => {
        const newValue = value[value.length - 1];
        const instantSettlement = formData.initial.instantSettlement;

        if (instantSettlement && newValue === 'ODS') {
            setSettlementConfirmation(true);
        }
        if(customError.odsActivation){
            setCustomError(preState => ({...preState, odsActivation: '' }));
        }
    };

    const previousSettlement = useRef([]);

    useEffect(() => {
        if (formData.values.sameDaySettlement && formData.values.sameDaySettlement.length >= 2) {
            if (previousSettlement.current.includes('ID')) {
                change('sameDaySettlement', ['ODS']);
                previousSettlement.current = ['ODS'];
            } else if (previousSettlement.current.includes('ODS')) {
                change('sameDaySettlement', ['ID']);
                previousSettlement.current = ['ID'];
            }
        } else {
            previousSettlement.current = formData.values.sameDaySettlement;
        }
    }, [formData.values.sameDaySettlement]);

    useEffect(() => {
        if (formData.initial && !formData.values.sameDaySettlement) {
            if (formData.initial.odsFlag === true) {
                change('sameDaySettlement', ['ODS']);
            } else if (formData.initial.instantSettlement === true) {
                change('sameDaySettlement', ['ID']);
            }
        }
    }, [change, formData.initial]);

    useEffect(() => {
        if ((isEditMode || isViewMode) && formData.initial) {
            if (formData.initial?.odsConfigInfo?.odSfeeInfo) {
                change(
                    'odsFeeCriteria',
                    formData.initial.odsConfigInfo.odSfeeInfo.feeType,
                );
                change(
                    'feePercent',
                    formData.initial.odsConfigInfo.odSfeeInfo.feePercent,
                );
                change(
                    'flatFee',
                    formData.initial.odsConfigInfo.odSfeeInfo.feeFlat,
                );
            }
        }
    }, [formData.initial?.odsConfigInfo?.odSfeeInfo]);


    useEffect(() =>{
        const field = isEditMode ? 'nextSettlementType' : 'settlementType';
        if(formData.values[field] === 'GROSS' && !formData.values?.sameDaySettlement?.includes('ODS')){
            setSettlementTypeOptions(preData => preData.map(item => {
                return item.value === 'ID' ? item : { ...item, isDisabled: true };
            }))
        }else if(formData.values[field] === 'GROSS' && formData.values?.sameDaySettlement?.includes('ODS')){
            dispatch(changeValue('add-settlement-form', field, 'NET'));
            setCustomError({
                odsActivation:
                    'Gross settlement cannot be enabled while ODS is active. Please disable ODS.',
            });
            setSettlementTypeOptions(initialSettlementTypeOptions);
        }else {
            setSettlementTypeOptions(initialSettlementTypeOptions);
        }
    }, [formData.values]);

    const hanldeReportClick = (event, reportType, isView) =>{
        event.preventDefault();
        setSelectedReportType(reportType);
        setIsMRViewMode(isView);
        setModalOpen(true);
    }

    useEffect(() => {

        if(!formData.initial?.narrationConfig?.interim?.interimType){
            change('narrationConfig.interim.interimType', 'BLANK')
        }
        if(!formData.initial?.narrationConfig?.secondInterim?.interimType){
            change('narrationConfig.secondInterim.interimType', 'BLANK')
        }
    }, [formData.initial]);


    return (
        <div className="settlement-tab">
             <TermsConditions
                 setModalOpen={setTermsConditionsView}
                 isOpen={termsConditionView}
             />
            <AlertModal
                modalIsOpen={formConfirmation}
                closeModal={onCloseConfirmation}
                primaryButtonText="OK"
                secondaryButtonText="CANCEL"
                showActions={true}
                onSuccessModal={onShowModalConfirmation}
                currentSection={currentStep}
                message={`Are you sure you want to ${isEditMode ? 'edit' : 'save'} the settlement details?`}
            />

            <AlertModal
                headerText={'Alert'}
                modalIsOpen={settlementConfirmation}
                closeModal={() => {
                    setSettlementConfirmation(false);
                    change('sameDaySettlement', ['ID']);
                }}
                primaryButtonText="OK"
                secondaryButtonText="CANCEL"
                showActions={true}
                onSuccessModal={() => {
                    setSettlementConfirmation(false);
                    change('sameDaySettlement', ['ODS']);
                }}
                message={`Instant settlement is on, are you sure you want to turn on on-demand settlement instead?`}
            />

            <form
                className="settlemnt-detail-form"
                onSubmit={handleSubmit(confirmFormConfirmation)}
            >
                <AlertModal
                    modalIsOpen={isShowModal}
                    closeModal={onCloseModal}
                    primaryButtonText="OK"
                    secondaryButtonText="CANCEL"
                    showActions={true}
                    onSuccessModal={onSuccessModal}
                    currentSection={currentStep}
                    message={`${getDependentSectionName(
                        onBoardSteps,
                        currentStep.dependentSections
                    )}
                    ${isOrAre} dependent on ${currentStep.name}
                    section. Please update dependent sections.`}
                />
                <div className="settlement-details card settlement-boarding">
                    <div>
                        <ul className="form-list">
                            <FieldArray
                                name="accountDetails"
                                component={renderAccounts}
                                props={{
                                    errorDetails,
                                    isEditMode,
                                    location,
                                    uniqueId,
                                    reRenderAccountDetails,
                                    ediConfInfoList: formData.values.ediConfInfoList,
                                    isViewMode
                                }}
                                isShowModal={isShowModalAccount}
                                setIsShowModal={setIsShowModalAccount}
                                accountErrorMessage={accountErrorMessage}
                                setAccountErrorMessage={setAccountErrorMessage}
                            />

                            <Accordion
                                customClass="rounded-accordion"
                                upperComponent={
                                    <h2 className="accordion-tile">
                                        Configuration Details
                                    </h2>
                                }
                                lowerComponent={
                                    <>
                                        <li className="form-section custom-section2">
                                            <div className="form-field">
                                                <p className="label">
                                                    Disbursement Cycle/Delay
                                                </p>
                                                <Field
                                                    name="disbursementCycle"
                                                    placeholder="Select Disbursement Cycle"
                                                    id="disbursement-cycle"
                                                    data={
                                                        basicFormData?.disbursementCycles
                                                            ? formatFormDataOptions(
                                                                basicFormData.disbursementCycles,
                                                            )
                                                            : []
                                                    }
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    label="Select Disbursement Cycle"
                                                    disabled={
                                                        isViewMode ||
                                                        formData.values
                                                            .settlementParty ===
                                                        'AGGREGATOR'
                                                    }
                                                />
                                            </div>

                                            {formData.values
                                                .disbursementCycle === 'T0' ? (
                                                <div className="form-field">
                                                    <p className="label">
                                                        Disbursement Interval
                                                    </p>
                                                    <Field
                                                        name="disbursementInterval"
                                                        placeholder="Select Interval"
                                                        id="trigger-slot"
                                                        data={
                                                            basicFormData?.disbursementIntervals
                                                                ? formatFormDataOptions(
                                                                    basicFormData.disbursementIntervals,
                                                                    'Hours',
                                                                )
                                                                : []
                                                        }
                                                        labelField="name"
                                                        valueField="value"
                                                        component={
                                                            FormElems.Select
                                                        }
                                                        label="Select Interval"
                                                        disabled={
                                                            isViewMode ||
                                                            formData.values
                                                                .settlementParty ===
                                                            'AGGREGATOR'
                                                        }
                                                    />
                                                </div>
                                            ) : (
                                                <div className="form-field">
                                                    <p className="label">
                                                        Disbursement Trigger
                                                        Slot
                                                    </p>
                                                    <Field
                                                        name="disbursementTriggerSlot"
                                                        placeholder="Select Slot"
                                                        id="trigger-slot"
                                                        data={
                                                            basicFormData?.disbursementTriggerSlots
                                                                ? formatFormDataOptions(
                                                                    basicFormData.disbursementTriggerSlots,
                                                                )
                                                                : []
                                                        }
                                                        labelField="name"
                                                        valueField="value"
                                                        component={
                                                            FormElems.Select
                                                        }
                                                        label="Select Slot"
                                                        disabled={
                                                            isViewMode ||
                                                            formData.values
                                                                .settlementParty ===
                                                            'AGGREGATOR'
                                                        }
                                                    />
                                                </div>
                                            )}
                                        </li>

                                        <li className="form-section">
                                            <div className="form-field">
                                                <p className="label">
                                                    Settlement Channel
                                                </p>
                                                <Field
                                                    name="fundTransferType"
                                                    placeholder="Settlement Channel"
                                                    id="settlement-party"
                                                    data={formatFormDataOptions(
                                                        [
                                                            'IMPS',
                                                            'NEFT',
                                                            'FUND_TRANSFER',
                                                        ],
                                                    )}
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    label="Select Settlement Channel"
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                            <div className="form-field">
                                                <p className="label">
                                                    Settlement Party
                                                </p>
                                                <Field
                                                    name="settlementParty"
                                                    placeholder="Select Party"
                                                    id="settlement-party"
                                                    data={
                                                        basicFormData?.settlementParty
                                                            ? formatFormDataOptions(
                                                                basicFormData.settlementParty,
                                                            )
                                                            : []
                                                    }
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    label="Select Party"
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field">
                                                <p className="label">
                                                    Settlement Type
                                                </p>
                                                <Field
                                                    name="settlementType"
                                                    placeholder="Select Type"
                                                    id="settlement-type"
                                                    wrapperClass="settlement-type-field"
                                                    data={
                                                        basicFormData?.settlementTypes
                                                            ? formatFormDataOptions(
                                                                basicFormData.settlementTypes,
                                                            )
                                                            : []
                                                    }
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    label="Select Type"
                                                    disabled={
                                                        isViewMode || isEditMode
                                                    }
                                                />
                                                <p className="error-message">
                                                    {!isEditMode ? customError.fcCommissionType || customError.fcCommissionType2 || customError.odsActivation : ''}
                                                </p>
                                            </div>
                                            <div className="form-field">
                                                {isEditMode && (
                                                    <>
                                                        <p className="label">
                                                            Next Settlement Type{' '}
                                                            <span className="feature-message">
                                                                (Next settlement
                                                                cycle will be
                                                                effective from{' '}
                                                                {settlementChangeDate()}
                                                                )
                                                            </span>
                                                        </p>
                                                        <Field
                                                            name="nextSettlementType"
                                                            placeholder="Select Type"
                                                            id="next-settlement-type"
                                                            wrapperClass="settlement-type-field"
                                                            data={
                                                                basicFormData?.settlementTypes
                                                                    ? formatFormDataOptions(
                                                                        basicFormData.settlementTypes,
                                                                    )
                                                                    : []
                                                            }
                                                            labelField="name"
                                                            valueField="value"
                                                            component={
                                                                FormElems.Select
                                                            }
                                                            label="Select Type"
                                                            disabled={
                                                                isViewMode
                                                            }
                                                        />
                                                        <p className="error-message">
                                                            {isEditMode ? customError.fcCommissionType || customError.fcCommissionType2 || customError.odsActivation : ''}
                                                        </p>
                                                    </>
                                                )}
                                            </div>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field form-field-switch">
                                                <p className="label">
                                                    Hierarchy Commission
                                                </p>
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        disabled={
                                                            !basicFormData ||
                                                            !basicFormData.commissionHierarchy ||
                                                            !basicFormData
                                                                .commissionHierarchy
                                                                .length
                                                        }
                                                        checked={
                                                            switchState.hierarchyCommission
                                                        }
                                                        onChange={() => {
                                                            setSwitchState({
                                                                ...switchState,
                                                                hierarchyCommission: !switchState.hierarchyCommission,
                                                            });
                                                            change(
                                                                'hierarchyCommission',
                                                                !switchState.hierarchyCommission,
                                                            );
                                                            setIsChange(true);
                                                        }}
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                            </div>
                                            <div className="form-field form-field-switch">
                                                <p className="label">
                                                    Zero Amount Settlement
                                                </p>
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            switchState.isZeroSettlementEnabled
                                                        }
                                                        onChange={() => {
                                                            if (isViewMode) return;
                                                            setSwitchState({
                                                                ...switchState,
                                                                isZeroSettlementEnabled: !switchState.isZeroSettlementEnabled,
                                                            });
                                                            change(
                                                                'isZeroSettlementEnabled',
                                                                !switchState.isZeroSettlementEnabled,
                                                            );
                                                        }}
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                            </div>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field form-field-switch">
                                                <p className="label">
                                                    Settlement Enabled
                                                </p>
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            switchState.isSettlementEnable
                                                        }
                                                        onChange={() => {
                                                            if (isViewMode) return;
                                                            setSwitchState({
                                                                ...switchState,
                                                                isSettlementEnable: !switchState.isSettlementEnable,
                                                            });

                                                            change(
                                                                'isSettlementEnable',
                                                                !switchState.isSettlementEnable,
                                                            );
                                                        }}
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                            </div>
                                            <div className="form-field form-field-switch">
                                                <p className="label">
                                                    Payable Enabled
                                                </p>
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            switchState.isPayableEnable
                                                        }
                                                        onChange={() => {
                                                            if (isViewMode) return;
                                                            setSwitchState({
                                                                ...switchState,
                                                                isPayableEnable: !switchState.isPayableEnable,
                                                            });
                                                            change(
                                                                'isPayableEnable',
                                                                !switchState.isPayableEnable,
                                                            );
                                                        }}
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                            </div>
                                        </li>

                                        <li className="form-section">
                                            <div className="form-field form-field-switch">
                                                <p className="label">
                                                    Refund with Negative Balance
                                                </p>
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            switchState.refundWithNegativeBalanceFlag
                                                        }
                                                        onChange={() => {
                                                            if (isViewMode) return;
                                                            setSwitchState({
                                                                ...switchState,
                                                                refundWithNegativeBalanceFlag: !switchState.refundWithNegativeBalanceFlag,
                                                            });

                                                            change(
                                                                'refundWithNegativeBalanceFlag',
                                                                !switchState.refundWithNegativeBalanceFlag,
                                                            );
                                                        }}
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                            </div>
                                            <div className="form-field"/>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field">
                                                {switchState.refundWithNegativeBalanceFlag && (
                                                    <>
                                                        <p className="label">
                                                            Refund Amount
                                                        </p>
                                                        <Field
                                                            name="refundThreshold"
                                                            type="number"
                                                            id="refund-amount"
                                                            component={
                                                                FormElems.Input
                                                            }
                                                            placeholder="Enter Refund Amount"
                                                            disabled={isViewMode}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                            <div className="form-field"/>
                                        </li>

                                        <li className="form-section">
                                            {switchState.hierarchyCommission ? (
                                                <div className="form-field">
                                                    <Field
                                                        name="hierarchyCommissionList"
                                                        component={
                                                            FormElems.Checkbox
                                                        }
                                                        labelField="label"
                                                        onChange={() =>
                                                            setIsChange(true)
                                                        }
                                                        options={[
                                                            {
                                                                label:
                                                                    'Aggregator',
                                                                value:
                                                                    'AGGREGATOR',
                                                                checked: false,
                                                                isSingleDisable:
                                                                    basicFormData.commissionHierarchy &&
                                                                    !basicFormData.commissionHierarchy.includes(
                                                                        'AGGREGATOR',
                                                                    ),
                                                            },
                                                            {
                                                                label:
                                                                    'Franchise',
                                                                value:
                                                                    'FRANCHISE',
                                                                checked: false,
                                                                isSingleDisable:
                                                                    basicFormData.commissionHierarchy &&
                                                                    !basicFormData.commissionHierarchy.includes(
                                                                        'FRANCHISE',
                                                                    ),
                                                            },
                                                            {
                                                                label: 'MLE',
                                                                value: 'MLE',
                                                                checked: false,
                                                                isSingleDisable:
                                                                    basicFormData.commissionHierarchy &&
                                                                    !basicFormData.commissionHierarchy.includes(
                                                                        'MLE',
                                                                    ),
                                                            },
                                                        ]}
                                                        valueField="value"
                                                    />
                                                </div>
                                            ) : (
                                                <div
                                                    className="form-field refund-amount"
                                                    style={{ marginRight: 26 }}
                                                />
                                            )}

                                            <div className="form-field "></div>
                                        </li>

                                        <li className="form-section">
                                            <div className="form-field checkbox-wrap modeCheck">
                                                <p className="label">
                                                    Fee Type
                                                </p>
                                                <Field
                                                    name="fcCommissionType"
                                                    component={FormElems.Radio}
                                                    labelField="name"
                                                    wrapperClass="wrap-checkbox"
                                                    onChange={() =>
                                                        setIsChange(true)
                                                    }
                                                    options={
                                                        formData?.values
                                                            ?.settlementType ===
                                                        'GROSS'
                                                            ? [
                                                                {
                                                                    name:
                                                                        'MDR',
                                                                    value:
                                                                        'MDR',
                                                                },
                                                            ]
                                                            : [
                                                                {
                                                                    name:
                                                                        'MDR',
                                                                    value:
                                                                        'MDR',
                                                                },
                                                                {
                                                                    name:
                                                                        'Surcharge',
                                                                    value:
                                                                        'SURCHARGE',
                                                                },
                                                            ]
                                                    }
                                                    valueField="value"
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                            {formData.values
                                                .disbursementCycle === 'T0' && (
                                                <div className="form-field checkbox-wrap modeCheck">
                                                    <p className="label">
                                                        Same Day Settlement Fee
                                                        Base
                                                    </p>
                                                    <Field
                                                        name="sameDaySettlementCharge"
                                                        component={
                                                            FormElems.Radio
                                                        }
                                                        labelField="name"
                                                        wrapperClass="wrap-checkbox"
                                                        options={[
                                                            {
                                                                name:
                                                                    'Net Amount',
                                                                value: 'NET',
                                                            },
                                                            {
                                                                name:
                                                                    'Gross Amount',
                                                                value: 'GROSS',
                                                            },
                                                        ]}
                                                        valueField="value"
                                                        disabled={isViewMode}
                                                    />
                                                </div>
                                            )}
                                        </li>

                                        <li className="form-section">
                                            <div className="form-field checkbox-wrap">
                                                <p className="label">Settlement type</p>
                                                <Field
                                                    name="sameDaySettlement"
                                                    component={FormElems.Checkbox}
                                                    labelField="name"
                                                    wrapperClass="wrap-checkbox"
                                                    onChange={handleSettlementChange}
                                                    options={settlementTypeOptions}
                                                    valueField="value"
                                                    isDisabled={isViewMode}
                                                />
                                            </div>
                                            {formData.values.sameDaySettlement?.includes('ODS') && (
                                                <div className="form-field checkbox-wrap">
                                                    <p className="label">Min ODS Amount</p>
                                                    <Field
                                                        name="odsConfigInfo.minOdsAmount"
                                                        type="number"
                                                        id="minOdsAmount"
                                                        component={FormElems.Input}
                                                        placeholder="Enter Min ODS Amount"
                                                        disabled={isViewMode}
                                                    />
                                                </div>
                                            )}
                                        </li>

                                       {formData.values.sameDaySettlement?.includes('ODS') && (
                                            <li className="form-section">
                                                <div className="form-field checkbox-wrap">
                                                    <p className="label">No. of ODS in a day</p>
                                                    <Field
                                                        name="odsConfigInfo.numberOfOdsInDay"
                                                        type="number"
                                                        id="numberOfOdsInDay"
                                                        component={FormElems.Input}
                                                        placeholder="Enter No. of ODS in a day"
                                                        disabled={isViewMode}
                                                    />
                                                </div>
                                                <div className="form-field checkbox-wrap">
                                                    <div className={'custom-terminal-label settlement'}>
                                                        <p className="label">Cooling Period</p>
                                                        <Tooltip
                                                            overlayStyle={{ width: '300px ' }}
                                                            placement="top"
                                                            overlay={
                                                                ' The cooling period between two ODS in a day. Enter value in minutes.'
                                                            }
                                                        >
                                                            <img src={infoIcon} alt={`info`} />
                                                        </Tooltip>
                                                    </div>
                                                    <Field
                                                        name="odsConfigInfo.coolingPeriod"
                                                        type="number"
                                                        id="coolingPeriod"
                                                        component={FormElems.Input}
                                                        placeholder="Enter Cooling Period"
                                                        disabled={isViewMode}
                                                    />
                                                </div>
                                            </li>
                                       )}

                                        <li className="form-section">
                                            <div className="form-field checkbox-wrap">
                                                <p className="label">
                                                    Ancillary Fee
                                                </p>
                                                <Field
                                                    name="isAncillaryFeeEnabled"
                                                    component={
                                                        FormElems.Checkbox
                                                    }
                                                    options={getCheckboxOptions(
                                                        formData.values,
                                                        ancillaryFeeOptions,
                                                        'isAncillaryFeeEnabled',
                                                    )}
                                                    wrapperClass="wrap-checkbox"
                                                    labelField="name"
                                                    valueField="value"
                                                    isDisabled={isViewMode}
                                                />
                                            </div>
                                        </li>
                                    </>
                                }
                            />

                            <Accordion
                                customClass="rounded-accordion"
                                upperComponent={
                                    <h2 className="accordion-tile">
                                        MSR & MTR
                                    </h2>
                                }
                                lowerComponent={
                                    <div className="reports-container">
                                      <div className="report-card">
                                        <div className="report-header">
                                          <div className="report-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8Z" stroke="currentColor" strokeWidth="2"/>
                                              <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2"/>
                                            </svg>
                                          </div>
                                          <h3 className="report-title">MSR Report</h3>
                                        </div>

                                        <div className="report-content">
                                          <p className="report-description">View or edit Merchant Settlement Report configurations</p>

                                          <div className="report-actions">
                                            <button
                                              className="action-button view-button"
                                              onClick={(event) => hanldeReportClick(event, 'MSR', true)}
                                            >
                                              <span className="button-icon">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M8 3.5C4.75 3.5 2 8 2 8C2 8 4.75 12.5 8 12.5C11.25 12.5 14 8 14 8C14 8 11.25 3.5 8 3.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                  <path d="M8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                              </span>
                                              <span>View</span>
                                            </button>

                                            {!isViewMode && (
                                              <button
                                                className="action-button edit-button"
                                                onClick={(event) => hanldeReportClick(event, 'MSR', false)}
                                              >
                                                <span className="button-icon">
                                                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 13.5H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M11 2.5C11.3978 2.10217 11.9374 1.87868 12.5 1.87868C13.0626 1.87868 13.6022 2.10217 14 2.5C14.3978 2.89782 14.6213 3.43739 14.6213 4C14.6213 4.56261 14.3978 5.10217 14 5.5L4.5 15L1 14L2 10.5L11 2.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                  </svg>
                                                </span>
                                                <span>Edit</span>
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="report-card">
                                        <div className="report-header">
                                          <div className="report-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z" stroke="currentColor" strokeWidth="2"/>
                                              <path d="M7 13L10 16L17 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                          </div>
                                          <h3 className="report-title">MTR Report</h3>
                                        </div>

                                        <div className="report-content">
                                          <p className="report-description">View or edit Merchant Transaction Report configurations</p>

                                          <div className="report-actions">
                                            <button
                                              className="action-button view-button"
                                              onClick={(event) => hanldeReportClick(event, 'MTR', true)}
                                            >
                                              <span className="button-icon">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M8 3.5C4.75 3.5 2 8 2 8C2 8 4.75 12.5 8 12.5C11.25 12.5 14 8 14 8C14 8 11.25 3.5 8 3.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                  <path d="M8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                              </span>
                                              <span>View</span>
                                            </button>

                                            {!isViewMode && (
                                              <button
                                                className="action-button edit-button"
                                                onClick={(event) => hanldeReportClick(event, 'MTR', false)}
                                              >
                                                <span className="button-icon">
                                                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 13.5H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M11 2.5C11.3978 2.10217 11.9374 1.87868 12.5 1.87868C13.0626 1.87868 13.6022 2.10217 14 2.5C14.3978 2.89782 14.6213 3.43739 14.6213 4C14.6213 4.56261 14.3978 5.10217 14 5.5L4.5 15L1 14L2 10.5L11 2.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                  </svg>
                                                </span>
                                                <span>Edit</span>
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="report-card toggle-card">
                                        <div className="toggle-header">
                                          <div className="toggle-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M17 7L7 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                              <path d="M7 7L17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                            </svg>
                                          </div>
                                          <h3 className="toggle-title">Unified MSR</h3>
                                        </div>

                                        <div className="toggle-content">
                                          <p className="toggle-description">Enable unified Merchant Settlement Report</p>

                                          <div className="toggle-control">
                                            <Field
                                              name="isUnifiedMsr"
                                              component={FormElems.Checkbox}
                                              options={getCheckboxOptions(
                                                formData.values,
                                                UnifiedMSROptions,
                                                'isUnifiedMsr'
                                              )}
                                              wrapperClass="modern-checkbox"
                                              labelField="name"
                                              valueField="value"
                                              isDisabled={isViewMode}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      {modalOpen && (
                                        <MerchantReportModal
                                          setModalOpen={setModalOpen}
                                          selectedReportType={selectedReportType}
                                          sectionType={sectionType}
                                          handleCombinedReports={handleCombinedReports}
                                          reportParameters={reportParameters}
                                          setReportParameters={setReportParameters}
                                          isMRViewMode={isMRViewMode}
                                        />
                                      )}
                                    </div>
                                }
                            />

                            <Accordion
                                customClass="rounded-accordion"
                                upperComponent={
                                    <h2 className="accordion-tile">
                                        Narration Details
                                    </h2>
                                }
                                lowerComponent={
                                    <>
                                        <li className="form-section">
                                            <div className="form-field">
                                                <p className="label">
                                                    Narration Prefix Type
                                                </p>
                                                <Field
                                                    name="narrationConfig.prefix.prefixType"
                                                    placeholder="Enter Narration Prefix Type"
                                                    id="narrationConfig.prefix.prefixType"
                                                    data={nameValueOptions([
                                                        'BLANK',
                                                        'FCPG',
                                                        'FUND_TRANSFER_FCPG',
                                                        'FCPG_FUND_TRANSFER',
                                                        'CUSTOM',
                                                    ])}
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    label="Enter Narration Identifier"
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                            <div className="form-field">
                                                <p className="label">
                                                    Custom Narration Prefix
                                                </p>
                                                <Field
                                                    name="narrationConfig.prefix.customPrefixIdentifier"
                                                    type="text"
                                                    id="narrationConfig.prefix.customPrefixIdentifier"
                                                    component={FormElems.Input}
                                                    placeholder="Enter Custom Narration Prefix"
                                                    disabled={
                                                        isViewMode ||
                                                        formData?.values
                                                            ?.narrationConfig
                                                            ?.prefix
                                                            ?.prefixType !==
                                                            'CUSTOM'
                                                    }
                                                />
                                            </div>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field">
                                                <p className="label">
                                                    Narration Interim Part 1
                                                </p>
                                                <Field
                                                    name="narrationConfig.interim.interimType"
                                                    placeholder="Enter Narration Interim Part 1"
                                                    id="narrationConfig.interim.interimType"
                                                    data={nameValueOptions(
                                                        interimOptions
                                                    )}
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                            <div className="form-field">
                                                <p className="label">
                                                    Narration Interim Part 2
                                                </p>
                                                <Field
                                                    name="narrationConfig.secondInterim.interimType"
                                                    placeholder="Enter Narration Interim Part 2"
                                                    id="narrationConfig.secondInterim.interimType"
                                                    data={nameValueOptions(
                                                        secondInterimOptions
                                                    )}
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    disabled={
                                                        isViewMode ||
                                                        !formData?.values
                                                            ?.instantSettlement
                                                    }
                                                />
                                            </div>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field">
                                                <p className="label">
                                                    Narration Suffix Type
                                                </p>
                                                <Field
                                                    name="narrationConfig.suffix.suffixType"
                                                    placeholder="Enter Narration Suffix Type"
                                                    id="narrationConfig.suffix.suffixType"
                                                    data={nameValueOptions([
                                                        'BLANK',
                                                        'DATE',
                                                        'CUSTOM',
                                                    ])}
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    label="Enter Narration Suffix"
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                            <div className="form-field">
                                                <p className="label">
                                                    Custom Narration Suffix
                                                </p>
                                                <Field
                                                    name="narrationConfig.suffix.customSuffixIdentifier"
                                                    type="text"
                                                    id="narrationConfig.suffix.customSuffixIdentifier"
                                                    component={FormElems.Input}
                                                    placeholder="Enter Custom Narration Suffix"
                                                    disabled={
                                                        isViewMode ||
                                                        formData?.values
                                                            ?.narrationConfig
                                                            ?.suffix
                                                            ?.suffixType !==
                                                            'CUSTOM'
                                                    }
                                                />
                                            </div>
                                        </li>
                                    </>
                                }
                            />
                        </ul>
                    </div>
                    {
                        process.env.REACT_APP_EDI_ENEBLED === 'true' && (
                            <FieldArray
                                name="ediConfInfoList"
                                component={renderSettlements}
                                props={{ basicFormData, formData, isViewMode, isEditMode }}
                                bankList={formData.values.accountDetails}
                                isShowModal={isShowModalSettlement}
                                setIsShowModal={setIsShowModalSettlement}
                                errorMessage={settlementErrorMessage}
                                setErrorMessage={setSettlementErrorMessage}
                                change={change}
                                setTermsConditionsView={setTermsConditionsView}
                                initialData={formData.initial}
                            />
                        )
                    }
                </div>
                <div className="form-section action">
                    {!isViewMode && (
                        <>
                        {previousPath ? (
                            <FormElems.Button
                                id="back-btn"
                                buttonType="secondary"
                                text="BACK"
                                type="button"
                                handleClick={onBack}
                                customClass="back-btn"
                            />
                        ) : null}
                        <FormElems.Button
                            id="next-btn"
                            buttonType="primary"
                            text={getFormButtonText(isUserTerminalState)}
                        />
                    </>
                    )}
                </div>
            </form>
        </div>
    );
};

const renderAccounts = ({
    fields,
    meta: { error, submitFailed },
    isViewMode,
    errorDetails,
    isShowModal,
    setIsShowModal,
    accountErrorMessage,
    setAccountErrorMessage,
    isEditMode,
    location,
    uniqueId,
    reRenderAccountDetails,
    ediConfInfoList
}) => {


    const onSuccessModal = () => {
        setIsShowModal(false);
        setAccountErrorMessage("");
    };

    const getIsEmpty = preAccount => {
        return (
            preAccount.accountHolderName === '' ||
            preAccount.accountNumber === '' ||
            preAccount.accountOwnership === '' ||
            preAccount.bankName === '' ||
            preAccount.ifscCode === ''
        );
    };

    const handleAddAccount = () => {
        const data = fields.getAll();
        const len = data?.length;
        if (len && getIsEmpty(data[len - 1])) {
            setAccountErrorMessage(`Please complete the previous bank account details before adding a new one.`);
            return setIsShowModal(true);
        }else if(len >= 2){
            setAccountErrorMessage(`Only two bank accounts are allowed.`);
            return setIsShowModal(true);
        }
        fields.push({ ...initialBankAccount, primary: false });
    };

    const handleOnChange = (e, index) => {
        const { checked } = e.target;
        if (checked) {
            fields.map((item, idx) => {
                if (idx === index) {
                    fields.get(idx).primary = true;
                } else {
                    fields.get(idx).primary = false;
                }
            });
        }
    };

    const handleAccountOwnerShip = (value, index) => {
        if (value === 'LENDER') {
            fields.get(index).primary = false;
        }else if(value === "SELF"){
            delete fields.get(index).ediDocs;
        }
    };

    const removeAccount = index => {
        fields.remove(index);
    };

    const getModifiedErrorMessage = errorDetails => {
        const error = errorDetails.error.errorMessage;

        if (error.includes(',')) {
            const formattedMessage = error
                .split(',')
                .map(segment => segment.trim())
                .join('\n');
            return formattedMessage;
        }

        return error;
    };



    async function uploadImageAndGetURL(file, name) {
        const formData = new FormData();
        formData.append('multipartFile', file);
        if (isEditMode) {
            const merchantId = last(location.pathname.split('/'));
            formData.append('merchantId', merchantId);
        } else {
            formData.append('uniqueIdentifier', uniqueId);
        }
        const headers = {
            'Content-Type': 'multipart/form-data;',
        };
        try {
            const response = await POST(
                API_UPLOAD_KYC_DOCUMENT,
                formData,
                headers,
                true
            );
            const { data } = response;
            if (data && data.statusCode === apiStatusCodes.SUCCESS) {
                toast.info('File upload successful');
                return data.s3Path;
            }
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        } catch (error) {
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        }
    }
    async function handleViewClick(docUrl) {
        const request = {
            s3Path: docUrl,
        };
        try {
            const response = await POST(
                API_VIEW_KYC_DOCUMENT,
                request,
                {},
                true
            );
            const { data } = response;
            if (data && data.statusCode === apiStatusCodes.SUCCESS) {
                window.open(data.s3Url, '_blank');
            } else {
                toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
            }
        } catch (error) {
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        }
    }



    return (
        <div>
            <AlertModal
                headerText="Alert"
                modalIsOpen={isShowModal}
                primaryButtonText="OK"
                showActions={true}
                onSuccessModal={onSuccessModal}
                message={accountErrorMessage}
            />

            <h2 className="tab-title custom-header">
                <p>Accounts & Settlement Details</p>
                {/* AS per requirement we are disableing EDI  */}
                {!isViewMode &&(
                    process.env.REACT_APP_EDI_ENEBLED === 'true' && (
                        <p className="add-bank addBackAccount" onClick={handleAddAccount}>
                            + Add bank account
                        </p>
                    )
                )}

            </h2>
            {errorDetails.error && errorDetails.error.errorMessage ? (
                <Alert customClass="error-msg">
                    {getModifiedErrorMessage(errorDetails)}
                </Alert>
            ) : null}
            {fields.map((name, index) => {
                const isCreate = fields.get(index).isCreate;
                const accountNumber = fields.get(index).accountNumber; // Assuming accountNumber is part of each field's data
                const lastFourDigits = accountNumber?.slice(-4);

                const ifscCodeFirstFour = fields
                    .get(index)
                    .ifscCode?.slice(0, 4); // Get first 4 digits of IFSC code
                const ifscCodeLastFour = fields.get(index).ifscCode?.slice(-4);

                const handleFileChange = (value, idx) => {
                    // Clone the fields array to avoid mutating the original state
                    const updatedFields = [...fields.getAll()];
                    const field = updatedFields[index]; // Access the field at the given index

                    if (field) {
                        // Ensure the ediDocs array exists
                        if (!field.ediDocs) {
                            field.ediDocs = [];
                        }

                        if (value === "") {
                            // Remove the element at idx
                            field.ediDocs.splice(idx, 1);
                        } else {
                            // Update the value at the specified index
                            field.ediDocs[idx] = value;
                        }
                    }

                    // Re-render with the updated fields
                    reRenderAccountDetails(updatedFields);
                };

                const isAddedOnEDI = !isCreate && ediConfInfoList && ediConfInfoList
                    .filter(item => !!item.accountNumber && !item.isCreate)
                    .find(item => item.accountNumber === fields.get(index).accountNumber && !fields.get(index).primary);

                console.log(isAddedOnEDI, "isAddedOnEDI");

                return (
                    <div key={index}>

                        <div className="close-btn-container">
                            {isCreate && index !== 0  && (
                                <p onClick={() => removeAccount(index)}>
                                    <span>&times;</span> Remove
                                </p>
                            )}
                        </div>
                        <div>
                            <Accordion
                                isOpened={index === 0}
                                customClass={`rounded-accordion `}
                                id={`account-accordion-${index}`}
                                upperComponent={
                                    <h3 className="accordion-title custom-accordian-header">
                                        Account {index + 1} Details{' '}
                                        {lastFourDigits &&
                                            ifscCodeFirstFour &&
                                            ifscCodeLastFour && (
                                                <span
                                                    style={{
                                                        color: 'gray',
                                                        fontSize: '14px',
                                                    }}
                                                >
                                                    {fields.get(index).accountNumber.length > 4 ? `ENDING XXXX${lastFourDigits.slice(-4)}` : ""} {'| '}
                                                    {fields.get(index).ifscCode.length > 4 ? `XXXX${ifscCodeLastFour.slice(-4)}` : ""}
                                                    </span>
                                            )}{' '}
                                        {fields.get(index).primary && (
                                            <span className="add-bank" style={{ color: "#f16122"}}>
                                                Primary
                                            </span>
                                        )}
                                    </h3>
                                }
                                lowerComponent={
                                    <div>
                                        <li className="form-section ">
                                            <div className="form-field ">
                                                <p className="label">
                                                    Select Account Type
                                                </p>
                                                <Field
                                                    name={`${name}.accountOwnership`}
                                                    component={FormElems.Radio}
                                                    labelField="name"
                                                    wrapperClass="wrap-checkbox"
                                                    options={[
                                                        {
                                                            name: 'Self',
                                                            value: 'SELF',
                                                        },
                                                        {
                                                            name: 'Lender',
                                                            value: 'LENDER',
                                                        },
                                                    ]}
                                                    valueField="value"
                                                    disabled={isViewMode || isAddedOnEDI}
                                                    onChange={e =>
                                                        handleAccountOwnerShip(
                                                            e,
                                                            index
                                                        )
                                                    }
                                                />
                                            </div>
                                            {(fields.getAll()[index]
                                                .accountOwnership === 'SELF' ||
                                                !fields.getAll()[index]
                                                    .accountOwnership) && (
                                                <div className="form-field form-field-switch">
                                                    <p className="label">
                                                        Set as Primary
                                                    </p>
                                                    <label className="switch">
                                                        <Field
                                                            name={`${name}.primary`}
                                                            component="input"
                                                            type="checkbox"
                                                            disabled={
                                                                isViewMode || isAddedOnEDI
                                                            }
                                                            onChange={e =>
                                                                handleOnChange(
                                                                    e,
                                                                    index
                                                                )
                                                            }
                                                        />
                                                        <span className="slider round" />
                                                    </label>
                                                </div>
                                            )}
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field">
                                                <p className="label">
                                                    Bank Account Number
                                                </p>
                                                <Field
                                                    name={`${name}.accountNumber`}
                                                    type="number"
                                                    pattern={/^[A-Za-z0-9]+$/}
                                                    component={FormElems.Input}
                                                    placeholder="Enter Account number"
                                                    disabled={isViewMode || isAddedOnEDI}
                                                />
                                            </div>

                                            <div className="form-field">
                                                <p className="label">IFSC</p>
                                                <Field
                                                    name={`${name}.ifscCode`}
                                                    type="text"
                                                    component={FormElems.Input}
                                                    placeholder="Enter IFSC Code"
                                                    disabled={isViewMode || isAddedOnEDI}
                                                />
                                            </div>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field">
                                                <p className="label">
                                                    Bank Name
                                                </p>
                                                <Field
                                                    name={`${name}.bankName`}
                                                    type="text"
                                                    component={FormElems.Input}
                                                    placeholder="Enter Bank Name"
                                                    disabled={isViewMode || isAddedOnEDI}
                                                />
                                            </div>
                                            <div className="form-field">
                                                <p className="label">
                                                    Bank Account Holder Name
                                                </p>
                                                <Field
                                                    name={`${name}.accountHolderName`}
                                                    type="text"
                                                    component={FormElems.Input}
                                                    placeholder="Enter Holder Name"
                                                    disabled={isViewMode || isAddedOnEDI}
                                                />
                                            </div>
                                        </li>
                                        {
                                            fields.get(index)
                                                .accountOwnership === 'LENDER' && (
                                                <li className="form-section">
                                                    <div className="form-field">
                                                        {multipleAdditionalDoc.map((item, idx) => {
                                                            return (
                                                                <div
                                                                    className="multiple-form-section"
                                                                    key={idx}
                                                                >
                                                                    <FieldArray
                                                                        name={`${name}.ediDocs`}
                                                                        configuration={item}
                                                                        component={RenderMultiUpload}
                                                                        isViewMode={isViewMode}
                                                                        uploadImageAndGetURL={
                                                                            uploadImageAndGetURL
                                                                        }
                                                                        handleViewClick={handleViewClick}
                                                                        docUrls={fields.get(index).ediDocs}
                                                                        accountIdx={index}
                                                                        handleFileChange={handleFileChange}
                                                                    />
                                                                    <p>
                                                                        Only <span>.JPG</span>, <span>.JPEG</span>, <span>.PNG</span>, <span>.PDF</span>, <span>.DOC</span> and <span>.DOCX</span> files
                                                                        are allowed for upload, with a maximum file size
                                                                        of <span>50 MB</span>.
                                                                    </p>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    <div className="form-field"></div>
                                                </li>
                                            )
                                        }
                                    </div>
                                }
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

const renderSettlements = ({
    fields,
    meta: { error, submitFailed },
    isViewMode,
    basicFormData,
    bankList,
    formData,
    isShowModal,
    setIsShowModal,
    errorMessage,
    setErrorMessage,
    change,
    setTermsConditionsView,
    isEditMode,
    initialData
}) => {
    const onSuccessModal = () => {
        setErrorMessage('');
        setIsShowModal(false);
    };

    const getIsEmpty = data => {
        return !data.accountNumber;
    };

    const addSattlement = () => {
        const data = fields.getAll();
        const len = data?.length;
        if (len && getIsEmpty(data[len - 1])) {
            setErrorMessage(
                'Please complete the settlement details before adding a new one.',
            );
            return setIsShowModal(true);
        }

        fields.push(initialEDIData);
    };

    const removeSattlement = index => {
        fields.remove(index);
    };

    const getBankAccounts = idx => {
        const allAccounts = new Set(
            fields.getAll()
                ?.map(item => item.accountNumber),
        );

        const isEdiEnebled = (account) => {
            const ediDetails = fields.getAll()
                .find(item => item.accountNumber === account);
            if (!ediDetails) {
                return false;
            }
            return ediDetails.ediEnable;
        };

        const filteredAccountList = bankList
            ?.filter(item => !!item.accountNumber && !item.primary)
            .map((item, index) => ({ ...item, index }))
            .filter(
                item =>
                    !allAccounts.has(item.accountNumber) || item.index === idx || !isEdiEnebled(item.accountNumber),
            )
            .map(item => item.accountNumber);

        return filteredAccountList;
    };

    const handleEDIChange = (e, index) => {
        const { checked } = e.target;
        const isPreviouslyOn = initialData.ediConfInfoList[index].ediEnable;
        if (checked && !isPreviouslyOn) {
            setErrorMessage(
                'Please add a new EDI. Enabling the existing one is not allowed'
            );
            setIsShowModal(true);
            e.preventDefault();
        }
    };

    const handleConsentChange = (e, idx) => {
        const { checked } = e.target;

        const ediConfInfoList = fields.getAll().map((item, i) => {
            if (i === idx) {
                return { ...item, consent: checked };
            }
            return item;
        });
        change('ediConfInfoList', ediConfInfoList);
    };

    const handleDebitFrequencyChange = (val, idx) => {
        let isValid = true;
        const arr = fields.getAll();

        for(let i=0;i<arr.length;i++){
            if(i === idx){
                const settlementFrequency = arr[i].settlementFrequency;
                if(val === 'MONTHLY' && settlementFrequency === "DAILY"){
                    isValid = false;
                }
            }
        }

        if(!isValid){
            const ediConfInfoList = fields.getAll().map((item, i) => {
                if (i === idx) {
                    return { ...item, settlementFrequency: null };
                }
                return item;
            });
            change('ediConfInfoList', ediConfInfoList);
        }
    }


    const getSettlementFrequencyData = (idx) =>{
        let data = basicFormData.settlementFrequency;
        const isDebitMonthly = fields.getAll()[idx]
            .debitFrequency ===
        'MONTHLY';

        if(isDebitMonthly){
            data = basicFormData.settlementFrequency.filter(
                item =>
                    item !==
                    'DAILY'
            )
        }
        return data;
    }

    console.log(initialData, "initialDatainitialData");

    return (
        <div>
            <AlertModal
                headerText="Alert"
                modalIsOpen={isShowModal}
                primaryButtonText="OK"
                showActions={true}
                onSuccessModal={onSuccessModal}
                message={errorMessage}
            />
            <h2 className="tab-title custom-header nested-header">
                <p>Split Settlements</p>
                {!isViewMode && (
                    <p className="add-bank" onClick={addSattlement}>
                        {' '}
                        + Add split settlement details
                    </p>
                )}
            </h2>
            {fields.map((name, index) => {
                fields.get(index).settlementType = formData.values.settlementType;
                fields.get(index).debitFrequency = "DAILY";
                const isCreate = fields.get(index).isCreate;
                const ediEnable = fields.get(index).ediEnable;

                return (
                    <div key={index}>
                        <div className="close-btn-container">
                            {isCreate && (
                                <p onClick={() => removeSattlement(index)}>
                                    <span>&times;</span> Remove
                                </p>
                            )}
                        </div>
                        <div>
                            <Accordion
                                customClass="rounded-accordion"
                                id={`settlement-accordion-${index}`}
                                upperComponent={
                                    <h3 className="accordion-tile custom-accordian-header">
                                        <p>{`Split Settlement ${index + 1}`}</p>
                                    </h3>
                                }
                                lowerComponent={
                                    <ul className="form-list">
                                        <h3 className="form-nested-header">
                                            Debit Details
                                        </h3>
                                        <li className="form-section">
                                            <div className="form-field form-field-switch">
                                                <p className="label">
                                                    EDI Enabled
                                                </p>
                                                <label className="switch">
                                                    <Field
                                                        name={`${name}.ediEnable`}
                                                        component="input"
                                                        type="checkbox"
                                                        disabled={
                                                            isViewMode || isCreate
                                                        }
                                                        onChange={
                                                            (e) => handleEDIChange(e, index)
                                                        }
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                            </div>
                                            <div className="form-field form-field-switch"></div>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field">
                                                <p className="label">
                                                    Debit Type
                                                    <span className={"required-asterisk"}>*</span>
                                                </p>
                                                <Field
                                                    name={`${name}.debitType`}
                                                    placeholder="Select Debit Amount Type"
                                                    id={`debit-amount-type-${index}`}
                                                    wrapperClass="settlement-type-field"
                                                    data={
                                                        basicFormData?.debitTypes
                                                            ? formatFormDataOptions(
                                                                  basicFormData.debitTypes
                                                              )
                                                            : []
                                                    }
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    label="Select Debit Amount Type"
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="form-field">
                                                <p className="label">
                                                    Debit Frequency
                                                    <span className={"required-asterisk"}>*</span>
                                                </p>
                                                <Field
                                                    name={`${name}.debitFrequency`}
                                                    placeholder="Select Debit Frequency"
                                                    id={`debit-frequency-${index}`}
                                                    data={
                                                        basicFormData?.debitFrequency
                                                            ? formatFormDataOptions(
                                                                  basicFormData.debitFrequency
                                                              )
                                                            : []
                                                    }
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    label="Select Debit Frequency"
                                                    disabled={true}
                                                    // handleChange={handleDebitFrequencyChange}
                                                    onChange={(val) => handleDebitFrequencyChange(val, index)}
                                                />
                                            </div>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field">
                                                <p className="label">
                                                    Debit Amount
                                                    <span className={"required-asterisk"}>*</span>
                                                </p>
                                                <Field
                                                    name={`${name}.debitAmountPer`}
                                                    id={`debit-amount-${index}`}
                                                    type="number"
                                                    component={FormElems.Input}
                                                    placeholder="Enter Debit Amount"
                                                    disabled={isViewMode ||  !isCreate}
                                                />
                                            </div>
                                            <div className="form-field">
                                                {fields.getAll()[index]
                                                    .debitFrequency ===
                                                    'MONTHLY' && (
                                                    <>
                                                        <p className="label">
                                                            Monthly Debit Date
                                                            <span className={"required-asterisk"}>*</span>
                                                        </p>
                                                        <Field
                                                            name={`${name}.monthlyDebitDate`}
                                                            placeholder="Enter Monthly Debit Date"
                                                            id={`settlement-date-${index}`}
                                                            type="date"
                                                            component={
                                                                FormElems.Input
                                                            }
                                                            disabled={
                                                                isViewMode ||  !isCreate
                                                            }
                                                            min={new Date().toISOString().split('T')[0]}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                        </li>
                                        <h3 className="form-nested-header">
                                            Settlement Details
                                        </h3>
                                        <li className="form-section">
                                            <div className="form-field">
                                                <p className="label">
                                                    Settlement Amount Type
                                                    <span className={"required-asterisk"}>*</span>
                                                </p>
                                                <Field
                                                    name={`${name}.settlementAmountType`}
                                                    placeholder="Select Settlement Type"
                                                    id={`settlement-amount-type-${index}`}
                                                    wrapperClass="settlement-type-field"
                                                    data={
                                                        formatFormDataOptions(
                                                            basicFormData?.settlementAmountTypes
                                                        ) || []
                                                    }
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    label="Select Settlement Type"
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="form-field">
                                                <p className="label">
                                                    Settlement Frequency
                                                    <span className={"required-asterisk"}>*</span>
                                                </p>
                                                <Field
                                                    name={`${name}.settlementFrequency`}
                                                    placeholder="Select Settlement Frequency"
                                                    id={`settlement-frequency-${index}`}
                                                    data={
                                                        basicFormData?.settlementFrequency
                                                            ? formatFormDataOptions(getSettlementFrequencyData(index).filter(
                                                                item =>
                                                                    item !==
                                                                    'ANNUALLY'
                                                            ))
                                                            : []
                                                    }
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    label="Select Settlement Frequency"
                                                    disabled={isViewMode ||  !isCreate}
                                                />
                                            </div>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field">
                                                <p className="label">
                                                    Bank Account
                                                    <span className={"required-asterisk"}>*</span>
                                                </p>
                                                <Field
                                                    name={`${name}.accountNumber`}
                                                    placeholder="Select Settlement Bank Account"
                                                    id={`settlement-bank-account-${index}`}
                                                    wrapperClass="settlement-type-field"
                                                    data={
                                                        bankList
                                                            ? formatFormDataOptions(
                                                                  getBankAccounts(
                                                                      index
                                                                  )
                                                              )
                                                            : []
                                                    }
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    label="Select Settlement Bank Account"
                                                    disabled={isViewMode ||  !isCreate}
                                                />
                                            </div>
                                            <div className="form-field">
                                                <p className="label">
                                                    Settlement Type
                                                    <span className={"required-asterisk"}>*</span>
                                                </p>
                                                <Field
                                                    name={`${name}.settlementType`}
                                                    placeholder="Select Fee Type"
                                                    id={`fee-type-${index}`}
                                                    wrapperClass="settlement-type-field"
                                                    data={
                                                        formatFormDataOptions(
                                                            basicFormData?.settlementTypes
                                                        ) || []
                                                    }
                                                    labelField="name"
                                                    valueField="value"
                                                    component={FormElems.Select}
                                                    label="Select Fee Type"
                                                    disabled={true}
                                                />
                                            </div>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field">
                                                <div className="custom-field-section">
                                                    <p className="label">
                                                        Start Date
                                                    </p>
                                                    <span className={'required-asterisk'}>*</span>
                                                    <Tooltip
                                                        // trigger={['hover']}
                                                        placement="right"
                                                        overlay={
                                                            <div className="tooltip">
                                                                Monthly
                                                                settlement date
                                                                will be same as
                                                                start date
                                                            </div>
                                                        }
                                                    >
                                                        <img
                                                            className="info-image-section"
                                                            alt="info-img"
                                                            src={info_image}
                                                        />
                                                    </Tooltip>
                                                </div>
                                                <div>
                                                    <Field
                                                        name={`${name}.startDate`}
                                                        id={`start-date-${index}`}
                                                        type="date"
                                                        component={FormElems.Input}
                                                        placeholder="Enter Start Date"
                                                        disabled={isViewMode || !isCreate}
                                                        min={new Date().toISOString().split('T')[0]}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-field">
                                                <p className="label">
                                                    End Date
                                                </p>
                                                <Field
                                                    name={`${name}.endDate`}
                                                    id={`end-date-${index}`}
                                                    type="date"
                                                    component={FormElems.Input}
                                                    placeholder="Enter End Date"
                                                    disabled={isViewMode ||  !isCreate}
                                                    min={new Date().toISOString().split('T')[0]}
                                                />
                                            </div>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field">
                                                <p className="label">
                                                    Total Amount
                                                </p>
                                                <Field
                                                    name={`${name}.totalAmount`}
                                                    id={`total-amount-${index}`}
                                                    type="text"
                                                    component={FormElems.Input}
                                                    placeholder="Enter Total Amount"
                                                    disabled={isViewMode || !isCreate}
                                                />
                                            </div>
                                            <div className="form-field"></div>
                                        </li>
                                        <li className="form-section">
                                            <div className="form-field two">
                                                <Field
                                                    disabled={isViewMode || !isCreate}
                                                    name={`${name}.consent`}
                                                    label=""
                                                    component={
                                                        FormElems.SingleCheckbox
                                                    }
                                                    isChecked={
                                                        fields.get(index)
                                                            .consent
                                                    }
                                                    handleChange={e =>
                                                        handleConsentChange(
                                                            e,
                                                            index
                                                        )
                                                    }
                                                />
                                                <span>I confirm that all information provided is accurate and consent to the <span className="hyperlink" onClick={() => setTermsConditionsView(true)}>terms & conditions</span> of this settlement.</span>
                                            </div>
                                        </li>
                                    </ul>
                                }
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};


const RenderMultiUpload = ({
    fields,
    meta: { error, submitFailed },
    auth,
    isViewMode,
    configuration,
    handleViewClick,
    uploadImageAndGetURL,
    docUrls,
    setDocUrls,
    onlySingleFile,
    accountIdx,
    handleFileChange
}) => {

    if (fields.length <= 0) {
        fields.push(null);
    }


    return (
        <div
            className={`field-array-section ${
                onlySingleFile ? 'no-border' : ''
            } form-section`}
        >
            <div className="field-list-section">
                {fields.map((item, index) => (
                    <>
                        <div className="field-list">
                            <div className="form-field custom">
                                {index > 0 ? (
                                    // <div
                                    //     className={"custom-label"}
                                    //     style={{justifyContent: "flex-end"}}
                                    //     onClick={() => {
                                    //         handleFileChange("", index);
                                    //         fields.remove(index);
                                    //     }}
                                    //
                                    //     disabled={isViewMode}
                                    // >
                                    //     <span>&times;Remove</span>
                                    // </div>
                                    <>
                                    </>
                                ) : (
                                    <div className={"custom-label"}>
                                    <p className="label">
                                        {configuration.label}
                                    </p>
                                    </div>
                                )}

                                <Field
                                    handleChange={(name, value) =>
                                        handleFileChange(value, index)
                                    }
                                    uploadImageAndGetURL={uploadImageAndGetURL}
                                    docUrl={
                                     docUrls && docUrls.length > 0 ? docUrls[index]: null
                                    }
                                    handleView={handleViewClick}
                                    name={item}
                                    id={item}
                                    type={'file'}
                                    component={FormElems.UploadElement}
                                    placeholder={
                                        configuration.props.placeholder
                                    }
                                    disabled={isViewMode}
                                    accept={configuration.props.accept}
                                    allowedExtensions={allowedExtensions}
                                    labelName={"Document" + (index + 1)}
                                    MaxFileSize={50}
                                    MLEerrorMessage ="Please upload files in the allowed formats: jpg, jpeg, png, pdf, doc, or docx."
                                />
                            </div>
                        </div>
                    </>
                ))}
                <div className="action-container">
                    <div className="action">
                        {!(isViewMode || onlySingleFile) && (
                            <FormElems.Button
                                type="button"
                                buttonType="secondary"
                                id="add-document"
                                text={`+ ${configuration.label}`}
                                customClass="add-button"
                                isDisable={fields.length === 5}
                                handleClick={() => {
                                    fields.push(null);
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

RenderMultiUpload.propTypes = {
    fields: PropTypes.object,
    meta: PropTypes.object,
    auth: PropTypes.object,
    configuration: PropTypes.object,
    uniqueId: PropTypes.object,
    isViewMode: PropTypes.bool,
    isEditMode: PropTypes.bool,
    onlySingleFile: PropTypes.bool,
    handleViewClick: PropTypes.func,
    uploadImageAndGetURL: PropTypes.func,
    docUrls: PropTypes.object,
    setDocUrls: PropTypes.func,
};


SettlementTab.propTypes = {
    actions: PropTypes.object,
    merchantData: PropTypes.object.isRequired,
    auth: PropTypes.object,
    change: PropTypes.func,
    handleSubmit: PropTypes.func,
    history: PropTypes.object,
    nextPath: PropTypes.string,
    previousPath: PropTypes.string,
    sectionType: PropTypes.string,
    name: PropTypes.string,
    initialValues: PropTypes.object,
    isEditMode: PropTypes.bool,
    isViewMode: PropTypes.bool,
    editData: PropTypes.object,
    formData: PropTypes.object,
    draftData: PropTypes.object,
    staticData: PropTypes.object,
    onBoardSteps: PropTypes.array,
    isInEditMode: PropTypes.bool,
};

const mapStateToProps = ({
    auth,
    form,
    merchantData,
    editData,
    staticData,
    merchantLegalEntityData
}) => ({
    auth,
    formData: form['add-settlement-form'],
    merchantData,
    editData,
    staticData,
    merchantLegalEntityData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            saveAndContinueRequest,
            resetSaveDataSuccessKey,
            resetUpdateDataSuccessKey,
            getMerchantInfoRequest,
            fetchBasicFormData,
            updateSettlementDataRequest,
            addMerchantStepUpdateMakerRequest,
            submitStepFormRequest,
            getMerchantSectionInfoRequest,
            change,
        },
        dispatch
    ),
});

export default withRouter(
    compose(
        reduxForm({
            form: 'add-settlement-form',
            enableReinitialize: true,
            validate
        }),
        connect(mapStateToProps, mapDispatchToProps),
    )(SettlementTab)
);
